// extracted by mini-css-extract-plugin
export default {"block":"Block_block__1BtVq","itemsWrapper":"Block_itemsWrapper__3ZAwb","item":"Block_item__DoEhd"};